import { DatepickerGrid } from './DatepickerGrid';
import { useDatepickerStore } from '@/stores/DatepickerStore/DatepickerStore';
import { DatepickerSingleGridProps } from './DatepickerGrid.consts';
import { useEffect } from 'react';
import { DatepickerType } from '../../Datepicker.consts';

export const DatepickerSingleGrid: React.FC<DatepickerSingleGridProps> = ({
  presetDate,
}: DatepickerSingleGridProps) => {
  const { year, month, setDateFromString } = useDatepickerStore();

  useEffect(() => {
    if (presetDate) {
      setDateFromString(presetDate);
    }
  }, [presetDate]);

  return <DatepickerGrid month={month} year={year} type={DatepickerType.SINGLE} />;
};
